<div class="header">
    <h2>{{card?.name}}</h2>
    <span class="spacer"></span>
    <ng-container *ngIf="(addToDeck && !addToSpecificDeck()) || addToInventory; else addDeck">
        <button mat-raised-button class="add" [matMenuTriggerFor]="addMenu"><mat-icon>add</mat-icon> Add</button>
        <mat-menu #addMenu="matMenu">
            <button *ngIf="addToDeck" mat-menu-item (click)="addCardToDeck()" #decksMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="decksMenu">To Deck</button>
            <mat-menu #decksMenu="matMenu">
                <button mat-menu-item (click)="addCardToDeck(deck.id)" *ngFor="let deck of decks">{{deck?.name}} - {{deck.format}}</button>
            </mat-menu>
            <button *ngIf="addToInventory" mat-menu-item (click)="addCardToInventory()">To Inventory</button>
        </mat-menu>
    </ng-container>
    <ng-template #addDeck>
        <ng-container *ngIf="addToDeck && addToSpecificDeck(); else addInventory">
            <button mat-raised-button class="add" (click)="addCardToDeck()"><mat-icon>add</mat-icon> Add To Deck</button>
        </ng-container>
    </ng-template>
    <ng-template #addInventory>
        <ng-container *ngIf="addToInventory">
            <button mat-raised-button class="add" (click)="addCardToInventory()"><mat-icon>add</mat-icon> Add To Inventory</button>
        </ng-container>
    </ng-template>
    <button *ngIf="swappable" mat-raised-button class="swap" (click)="swapCard()"><mat-icon>swap_horiz</mat-icon> Swap Versions</button>
    <button *ngIf="removable" mat-raised-button class="remove" (click)="removeCard()"><mat-icon>remove</mat-icon> Remove</button>
</div>
<div class="wrapper">
    <app-card-image [card]="card" [width]="300" [quantity]="quantity" [clickable]="false" [hoverable]="false" [draggable]="false" (transform)="transformed = $event"></app-card-image>
    <ng-container *ngIf="card.cardFaces && card.cardFaces.length > 0 && card.layout !== 'adventure' && card.layout !== 'split'; else adventure">
        <div class="details">
            <div class="text">
                <h5>Card Text</h5>
                <p [innerHTML]="getCardText(card.cardFaces[(transformed ? 1 : 0)]) | async">Loading...</p>
                <p class="flavor-text">{{getFlavorText()}}</p>
            </div>
            <div class="sub-details">
                <div class="color-id">
                    <h5>Color Identity</h5>
                    <img *ngFor="let colorSymbol of cardSymbologyUtils.getSymbols(card.cardFaces[(transformed ? 1 : 0)].colors) | async" class="mana-symbol"
                         [matTooltip]="colorSymbol.english"
                         [alt]="colorSymbol.english"
                         [src]="colorSymbol.svgUri"/>
                </div>
                <div class="mana-cost">
                    <h5>Mana Cost</h5>
                    <img *ngFor="let manaSymbol of cardSymbologyUtils.getManaSymbols(card.cardFaces[(transformed ? 1 : 0)], 'mana_cost') | async" class="mana-symbol"
                         [matTooltip]="manaSymbol.english"
                         [alt]="manaSymbol.english"
                         [src]="manaSymbol.svgUri"/>
                </div>
                <div class="type">
                    <h5>Type</h5>
                    <p>{{getTypeLine(card.cardFaces[(transformed ? 1 : 0)])}}</p>
                </div>
                <div class="set">
                    <h5>Set</h5>
                    <ng-container *ngIf="(cardSymbologyUtils.getCardSet(card.set, card.rarity) | async) as cardSetAndSafeSvg">
                        <div [innerHTML]="cardSetAndSafeSvg.safeSvg" [matTooltip]="card.setName" class="{{card.rarity}}"></div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #adventure>
        <div class="detail-wrapper" *ngIf="card.cardFaces && (card.layout === 'adventure' || card.layout === 'split'); else normal">
            <div class="details" *ngFor="let face of card.cardFaces">
                <div class="text">
                    <h5>Card Text - {{face.name}}</h5>
                    <p [innerHTML]="getCardText(face) | async">Loading...</p>
                    <p class="flavor-text">{{getFlavorText()}}</p>
                </div>
                <div class="sub-details">
                    <div class="color-id">
                        <h5>Color Identity</h5>
                        <img *ngFor="let colorSymbol of cardSymbologyUtils.getSymbols(card.colorIdentity) | async" class="mana-symbol"
                             [matTooltip]="colorSymbol.english"
                             [alt]="colorSymbol.english"
                             [src]="colorSymbol.svgUri"/>
                    </div>
                    <div class="mana-cost">
                        <h5>Mana Cost</h5>
                        <img *ngFor="let manaSymbol of cardSymbologyUtils.getManaSymbols(face, 'mana_cost') | async" class="mana-symbol"
                             [matTooltip]="manaSymbol.english"
                             [alt]="manaSymbol.english"
                             [src]="manaSymbol.svgUri"/>
                    </div>
                    <div class="type">
                        <h5>Type</h5>
                        <p>{{getTypeLine(face)}}</p>
                    </div>
                    <div class="set">
                        <h5>Set</h5>
                        <ng-container *ngIf="(cardSymbologyUtils.getCardSet(card.set, card.rarity) | async) as cardSetAndSafeSvg">
                            <div [innerHTML]="cardSetAndSafeSvg.safeSvg" [matTooltip]="card.setName" class="{{card.rarity}}"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #normal>
        <div class="details">
            <div class="text">
                <h5>Card Text</h5>
                <p [innerHTML]="getCardText() | async">Loading...</p>
                <p class="flavor-text">{{getFlavorText()}}</p>
            </div>
            <div class="sub-details">
                <div class="color-id">
                    <h5>Color Identity</h5>
                    <img *ngFor="let colorSymbol of cardSymbologyUtils.getSymbols(card.colorIdentity) | async" class="mana-symbol"
                         [matTooltip]="colorSymbol.english"
                         [alt]="colorSymbol.english"
                         [src]="colorSymbol.svgUri"/>
                </div>
                <div class="mana-cost">
                    <h5>Mana Cost</h5>
                    <img *ngFor="let manaSymbol of cardSymbologyUtils.getManaSymbols(card, 'manaCost') | async" class="mana-symbol"
                         [matTooltip]="manaSymbol.english"
                         [alt]="manaSymbol.english"
                         [src]="manaSymbol.svgUri"/>
                </div>
                <div class="type">
                    <h5>Type</h5>
                    <p>{{getTypeLine()}}</p>
                </div>
                <div class="set">
                    <h5>Set</h5>
                    <ng-container *ngIf="(cardSymbologyUtils.getCardSet(card.set, card.rarity) | async) as cardSetAndSafeSvg">
                        <div [innerHTML]="cardSetAndSafeSvg.safeSvg" [matTooltip]="card.setName" class="{{card.rarity}}"></div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-template>
</div>
